// export const API_KEY = "6d75b2a2e2b05ca51b4dda2ad6426fda";
export const API_KEY = "a4b0fa2c9bc2b794d311870ca98efbd5";
export const TMDB_BASE_URL = "https://api.themoviedb.org/3";
